import React from "react";
import { useRouteMatch, Link, useParams, useLocation } from "react-router-dom";
import { useAuthState } from "../../../../components/AuthProvider";
import formattedDate from "../../../../utils/formattedDate";
import Container from "../../../../components/Container";
import Content from "../../../../components/Content";
import Flex from "../../../../components/Flex";
import Layout from "../../../../components/Layout";
import InnerTableComponent from "./InnerTableComponent";
import DefaultBreadcrumbs from "../../../../components/DefaultBreadcrumbs";
import Breadcrumbs from "../../../../components/Breadcrumbs";
import Breadcrumb from "../../../../components/Breadcrumbs";
import ButtonList from "../../../../components/ButtonList";
import Button from "../../../../components/Button";
import LinkButton from "../../../../components/LinkButton";
import Icon from "../../../../components/Icon";
import { checkReadOnlyUser } from "../../../../utils/checkReadOnlyUser.js";
import { formattedDateWithDefault } from "../../../../utils/formattedDate";
import { isImdmClient } from "../../../../utils/isImdmClient";
import styles from "./CompareRecords.module.scss";
import "../../../../components/PopOver/style.css";
import { FastField } from "formik";
import Modal from "../../../../components/ModalPopup";
import {
  fetchReviewQueueCountData,
  fetchBulkOrgData,
  fetchClientSubscriptionsData,
  aggregatesCall
} from "../../../../utils/fetchData";

const CompareRecords = ({
  overlayRecordsData = null,
  isQuarantineRecord = false,
  clientId,
  recordOverrideHandler,
  isRecordOverridden = false,
  focusIdentityButtonHandler,
  skipAndReviewHandler,
  applyAndResolveOverlayRecordHandler,
  fromSearchOverlay = false,
  disableApplyChanges = false
}) => {
  const { user } = useAuthState();
  const { page } = useParams();
  const { selectedClient } = user.preferences;
  const isImdm = isImdmClient(selectedClient);
  const [zoomValue, setZoomValue] = React.useState(1);
  const [zoomWidth, setZoomWidth] = React.useState(15);
  const [quarantineConfirmDialog, setQuarantineConfirmDialog] = React.useState(
    false
  );
  // let array = [];
  const [array, setArray] = React.useState([]);

  const [isOverlayRecordPage, setIsOverlayRecordPage] = React.useState(
    overlayRecordsData ? true : false
  );

  React.useEffect(() => {
    if (!isOverlayRecordPage) {
      const compareRaw = localStorage.getItem("compare");
      if (compareRaw) {
        const compareList = JSON.parse(compareRaw);
        const map = new Map(compareList[page]);
        const newArray = [];
        [...map].forEach(([, record]) => {
          newArray.push(record);
        });
        setArray(newArray);
        console.log("Updated array:", newArray);
      } else {
        setArray([]);
        console.warn("No compare data found in localStorage.");
      }
    } else if (overlayRecordsData) {
      // Handle overlay records
      setArray(overlayRecordsData);
      console.log("Updated array for overlay records:", overlayRecordsData);
    }
  }, [isOverlayRecordPage, overlayRecordsData, page]);

  const lastUpdatedTimeCell = updateDate => {
    if (updateDate === "Current") return updateDate;
    return updateDate ? formattedDateWithDefault(updateDate) : "";
  };

  console.log("**********");
  console.log(array);
  console.log("**********");

  const location = useLocation();

  React.useEffect(() => {
    if (location.pathname.includes("repartition-preview")) {
      setIsOverlayRecordPage(true);
    }
  }, [location.pathname]);

  const [
    beforeRepartitionRecords,
    setBeforeRepartitionRecords
  ] = React.useState([]);
  const [afterRepartitionData, setAfterRepartitionData] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(true);

  React.useEffect(() => {
    let retryCount = 0;
    const maxRetries = 10;
    const interval = setInterval(() => {
      const beforeData = localStorage.getItem("beforeRepartitionData");
      const afterData = localStorage.getItem("afterRepartitionData");

      if (beforeData && afterData) {
        const parsedBeforeData = JSON.parse(beforeData);
        const parsedAfterData = JSON.parse(afterData);
        setBeforeRepartitionRecords(() => {
          const entries = parsedBeforeData?.entry || [];
          return entries.map(e => e.resource);
        });
        setAfterRepartitionData(parsedAfterData);
        setIsLoading(false); // Stop loading once data is available
        clearInterval(interval); // Stop polling
      } else {
        retryCount++;
        if (retryCount >= maxRetries) {
          console.warn("Max retries reached. Stopping polling.");
          clearInterval(interval); // Stop polling after max retries
          setIsLoading(false); // Ensure loading state is reset
        }
      }
    }, 500); // Poll every 500ms

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  // 1. Parse AfterRepartition recordUpdates
  const [afterRepartitionMap, setAfterRepartitionMap] = React.useState({});
  const [
    afterRepartitionHasUpdates,
    setAfterRepartitionHasUpdates
  ] = React.useState(true);
  const [patients, setPatients] = React.useState([]);

  // Extract golden record (first entry)
  const goldenRecord = beforeRepartitionRecords[0];

  const searchedGoldenId = goldenRecord?.id;

  React.useEffect(() => {
    if (afterRepartitionData) {
      const updates = afterRepartitionData?.data?.recordUpdates || [];
      setAfterRepartitionHasUpdates(updates.length > 0);

      const patients = updates
        .map(update => {
          try {
            const demo = JSON.parse(update.demographics || "{}");
            demo._golden_id = update.golden_id;
            return {
              source_entity_id: update.source_entity_id,
              patient: demo
            };
          } catch (error) {
            console.error("Error parsing demographics:", error);
            return null; // Handle parsing errors gracefully
          }
        })
        .filter(item => item !== null); // Remove null entries caused by errors

      setPatients(patients);
      const afterMap = {};
      patients.forEach(({ patient }) => {
        if (patient && patient.id) {
          afterMap[patient.id] = patient;
        }
      });
      setAfterRepartitionMap(afterMap);
    }
  }, [afterRepartitionData]);

  // Track which afterRepartitionMap keys have been matched
  const matchedAfterIds = new Set();

  // Extract actual records (skip the first entry)
  const recordEntries = beforeRepartitionRecords.filter(record => {
    if (!record || !record.id) return false;
    if (record.id === searchedGoldenId) return false; // skip golden record itself
    // Only include if link[].other.reference matches searchedGoldenId
    if (Array.isArray(record.link)) {
      return record.link.some(
        l => l.other && l.other.reference === searchedGoldenId
      );
    }
    return false;
  });

  if (isQuarantineRecord) {
    // Handle quarantine records independently
    if (array.length === 0) {
      return <div>No quarantine records to compare</div>;
    }
  } else {
    // Handle repartition preview independently
    if (!afterRepartitionHasUpdates) {
      return <div>There will be no changes to this EID post repartition</div>;
    }
  }

  const getPreferredName = (record, isGolden = false) => {
    if (!record?.name || record.name.length === 0) return "";
    // For golden record, always use the first name (survived)
    if (isGolden) {
      const nameObj = record.name[0];
      return `${
        nameObj.given ? nameObj.given.join(" ") : ""
      } ${nameObj.family || ""}`.trim();
    }
    // For other records, prefer name with attrCode === "PERCHSNNAME"
    const chosen = record.name.find(
      n =>
        n.extension &&
        n.extension.some(
          e =>
            e.url &&
            e.url.includes("attrCode") &&
            e.valueString === "PERCHSNNAME"
        )
    );
    const nameObj = chosen || record.name[0];
    return `${nameObj.given ? nameObj.given.join(" ") : ""} ${nameObj.family ||
      ""}`.trim();
  };

  const sources = [];
  const familyNames = [];
  const givenNames = [];
  const nameUse = [];
  const addressLines1 = [];
  const addressLines2 = [];
  const cities = [];
  const postalCodes = [];
  const addressUse = [];
  const stateCode = [];
  const genders = [];
  const DOBs = [];
  const phones = [];
  const phoneUse = [];
  const emails = [];
  const emailUse = [];
  const SSNs = [];
  const MBIs = [];
  const HICNs = [];
  const MRNs = [];
  const CPINs = [];
  const HSIDs = [];
  const policyNum = [];
  const dependentCd = [];
  const divisionCd = [];
  const relationshipCd = [];
  const familyID = [];
  const memberID = [];
  const subscriberID = [];
  const carrierID = [];
  const accountID = [];
  const groupID = [];
  const origSysId = [];
  const medicaidRN = [];
  const coverageEndDate = [];
  const otherIdentifiers = [];
  const lastUpdated = [];

  for (const record of array) {
    let otherIdsString = "";
    let otherIdsCount = 0;

    if (record.meta.source && record.meta.source.length > 0) {
      sources.push(record.meta.source ? [record.meta.source] : []);
    } else {
      sources.push([]);
    }
    if (record.name && record.name.length > 0) {
      const filteredName = record.name.filter(name => name.use !== "old");
      familyNames.push(
        filteredName.map(name => (name.family ? name.family : ""))
      );
      givenNames.push(
        filteredName.map(name => (name.given ? name.given.join(" ") : ""))
      );
      nameUse.push(filteredName.map(name => (name.use ? name.use : "")));
    } else {
      familyNames.push([]);
      givenNames.push([]);
      nameUse.push([]);
    }

    if (record.address && record.address.length > 0) {
      const filteredAddress = record.address.filter(
        address => address.use !== "old"
      );
      addressLines1.push(
        filteredAddress.map(address =>
          address.line && address.line.length > 0 ? address.line[0] : ""
        )
      );
      addressLines2.push(
        filteredAddress.map(address =>
          address.line && address.line.length > 1 ? address.line[1] : ""
        )
      );
      cities.push(
        filteredAddress.map(address => (address.city ? address.city : ""))
      );
      postalCodes.push(
        filteredAddress.map(address =>
          address.postalCode ? address.postalCode : ""
        )
      );
      addressUse.push(
        filteredAddress.map(address => (address.use ? address.use : ""))
      );
      stateCode.push(
        filteredAddress.map(address => (address.state ? address.state : ""))
      );
    } else {
      addressLines1.push([]);
      addressLines2.push([]);
      cities.push([]);
      postalCodes.push([]);
      addressUse.push([]);
      stateCode.push([]);
    }

    if (record.telecom && record.telecom.length > 0) {
      const filteredTelecom = record.telecom.filter(
        telecom => telecom.use !== "old"
      );
      phones.push(
        filteredTelecom
          .filter(tel => tel.system === "phone" && tel.value)
          .map(tel =>
            tel.system === "phone" ? (tel.value ? tel.value : "") : ""
          )
      );
      phoneUse.push(
        filteredTelecom
          .filter(tel => tel.system === "phone" && tel.value)
          .map(tel => (tel.system === "phone" ? (tel.use ? tel.use : "") : ""))
      );
      emails.push(
        filteredTelecom
          .filter(tel => tel.system === "email" && tel.value)
          .map(tel =>
            tel.system === "email" ? (tel.value ? tel.value : "") : ""
          )
      );
      emailUse.push(
        filteredTelecom
          .filter(tel => tel.system === "email" && tel.value)
          .map(tel => (tel.system === "email" ? (tel.use ? tel.use : "") : ""))
      );
    } else {
      phones.push([]);
      phoneUse.push([]);
      emails.push([]);
      emailUse.push([]);
    }

    genders.push(record.gender ? [record.gender] : []);
    DOBs.push(record.birthDate ? [record.birthDate] : []);

    if (record.identifier && record.identifier.length > 0) {
      const filteredidentifier = record.identifier.filter(
        identifier => identifier.use !== "old"
      );
      SSNs.push(
        filteredidentifier
          .filter(
            identifiers =>
              identifiers.system === "http://hl7.org/fhir/sid/us-ssn" &&
              identifiers.value
          )
          .map(ssn => {
            ssn.isOtherIdentifier = false;
            return ssn.value;
          })
      );
      MBIs.push(
        filteredidentifier
          .filter(
            identifiers =>
              identifiers.system === "http://hl7.org/fhir/sid/us-mbi" &&
              identifiers.value
          )
          .map(mbi => {
            mbi.isOtherIdentifier = false;
            return mbi.value;
          })
      );

      HICNs.push(
        filteredidentifier
          .filter(
            identifiers =>
              identifiers.system === "http://hl7.org/fhir/sid/us-medicare" &&
              identifiers.value
          )
          .map(hicn => {
            hicn.isOtherIdentifier = false;
            return hicn.value;
          })
      );
      MRNs.push(
        filteredidentifier
          .filter(
            identifiers =>
              identifiers.type &&
              identifiers.type.coding &&
              identifiers.type.coding[0].code &&
              identifiers.type.coding[0].code === "MR" &&
              identifiers.value
          )
          .map(mrn => {
            mrn.isOtherIdentifier = false;
            return mrn.value;
          })
      );
      CPINs.push(
        filteredidentifier
          .filter(
            identifiers => identifiers.system === "cpin" && identifiers.value
          )
          .map(cpin => {
            cpin.isOtherIdentifier = false;
            return cpin.value;
          })
      );
      HSIDs.push(
        filteredidentifier
          .filter(
            identifiers =>
              identifiers.system === "healthSafeId" && identifiers.value
          )
          .map(hsid => {
            hsid.isOtherIdentifier = false;
            return hsid.value;
          })
      );
      filteredidentifier
        .filter(
          identifiers =>
            !identifiers.hasOwnProperty("isOtherIdentifier") &&
            !(
              "type" in identifiers &&
              "coding" in identifiers.type &&
              identifiers.type.coding.some(c => c.code === "COV")
            ) &&
            identifiers.value
        )
        .forEach(otherIds => {
          if (
            !isImdm ||
            (otherIds.system &&
              !user.preferences.sources.hasOwnProperty(otherIds.system) &&
              otherIds.system !== "imdm")
          ) {
            otherIdsCount++;
            otherIdsString = otherIdsString
              .concat(otherIdsCount > 1 ? `  |  ` : "")
              .concat(
                otherIds.system
                  ? otherIds.system
                  : otherIds.type &&
                    otherIds.type.coding &&
                    otherIds.type.coding[0] &&
                    otherIds.type.coding[0].code
                  ? otherIds.type.coding[0].code
                  : "-"
              )
              .concat(": ")
              .concat(otherIds.value);
          }
        });
      otherIdentifiers.push([otherIdsString]);
    } else {
      SSNs.push([]);
      MBIs.push([]);
      MRNs.push([]);
      HICNs.push([]);
      CPINs.push([]);
      HSIDs.push([]);
      otherIdentifiers.push([]);
    }
    if (record.identifier && record.identifier.length > 0) {
      const filteredCoverageIdentifier = record.identifier.filter(
        identifier => identifier.use !== "old"
      );
      policyNum.push(
        filteredCoverageIdentifier
          .filter(identifiers => {
            return (
              "type" in identifiers &&
              "coding" in identifiers.type &&
              identifiers.type.coding.some(c => c.code === "COV")
            );
          })
          .map(coverageidentifier => {
            const coverageValue = coverageidentifier.value
              ? JSON.parse(coverageidentifier.value)
              : {};
            return coverageValue.policyNum;
          })
      );
      dependentCd.push(
        filteredCoverageIdentifier
          .filter(identifiers => {
            return (
              "type" in identifiers &&
              "coding" in identifiers.type &&
              identifiers.type.coding.some(c => c.code === "COV")
            );
          })
          .map(coverageidentifier => {
            const coverageValue = coverageidentifier.value
              ? JSON.parse(coverageidentifier.value)
              : {};
            return coverageValue.dependentCd;
          })
      );
      divisionCd.push(
        filteredCoverageIdentifier
          .filter(identifiers => {
            return (
              "type" in identifiers &&
              "coding" in identifiers.type &&
              identifiers.type.coding.some(c => c.code === "COV")
            );
          })
          .map(coverageidentifier => {
            const coverageValue = coverageidentifier.value
              ? JSON.parse(coverageidentifier.value)
              : {};
            return coverageValue.divisionCd;
          })
      );
      relationshipCd.push(
        filteredCoverageIdentifier
          .filter(identifiers => {
            return (
              "type" in identifiers &&
              "coding" in identifiers.type &&
              identifiers.type.coding.some(c => c.code === "COV")
            );
          })
          .map(coverageidentifier => {
            const coverageValue = coverageidentifier.value
              ? JSON.parse(coverageidentifier.value)
              : {};
            return coverageValue.relationshipCd;
          })
      );
      familyID.push(
        filteredCoverageIdentifier
          .filter(identifiers => {
            return (
              "type" in identifiers &&
              "coding" in identifiers.type &&
              identifiers.type.coding.some(c => c.code === "COV")
            );
          })
          .map(coverageidentifier => {
            const coverageValue = coverageidentifier.value
              ? JSON.parse(coverageidentifier.value)
              : {};
            return coverageValue.familyID;
          })
      );
      memberID.push(
        filteredCoverageIdentifier
          .filter(identifiers => {
            return (
              "type" in identifiers &&
              "coding" in identifiers.type &&
              identifiers.type.coding.some(c => c.code === "COV")
            );
          })
          .map(coverageidentifier => {
            const coverageValue = coverageidentifier.value
              ? JSON.parse(coverageidentifier.value)
              : {};
            return coverageValue.memberID;
          })
      );
      subscriberID.push(
        filteredCoverageIdentifier
          .filter(identifiers => {
            return (
              "type" in identifiers &&
              "coding" in identifiers.type &&
              identifiers.type.coding.some(c => c.code === "COV")
            );
          })
          .map(coverageidentifier => {
            const coverageValue = coverageidentifier.value
              ? JSON.parse(coverageidentifier.value)
              : {};
            return coverageValue.subscriberID;
          })
      );
      carrierID.push(
        filteredCoverageIdentifier
          .filter(identifiers => {
            return (
              "type" in identifiers &&
              "coding" in identifiers.type &&
              identifiers.type.coding.some(c => c.code === "COV")
            );
          })
          .map(coverageidentifier => {
            const coverageValue = coverageidentifier.value
              ? JSON.parse(coverageidentifier.value)
              : {};
            return coverageValue.carrierID;
          })
      );
      accountID.push(
        filteredCoverageIdentifier
          .filter(identifiers => {
            return (
              "type" in identifiers &&
              "coding" in identifiers.type &&
              identifiers.type.coding.some(c => c.code === "COV")
            );
          })
          .map(coverageidentifier => {
            const coverageValue = coverageidentifier.value
              ? JSON.parse(coverageidentifier.value)
              : {};
            return coverageValue.accountID;
          })
      );
      groupID.push(
        filteredCoverageIdentifier
          .filter(identifiers => {
            return (
              "type" in identifiers &&
              "coding" in identifiers.type &&
              identifiers.type.coding.some(c => c.code === "COV")
            );
          })
          .map(coverageidentifier => {
            const coverageValue = coverageidentifier.value
              ? JSON.parse(coverageidentifier.value)
              : {};
            return coverageValue.groupID;
          })
      );
      origSysId.push(
        filteredCoverageIdentifier
          .filter(identifiers => {
            return (
              "type" in identifiers &&
              "coding" in identifiers.type &&
              identifiers.type.coding.some(c => c.code === "COV")
            );
          })
          .map(coverageidentifier => {
            const coverageValue = coverageidentifier.value
              ? JSON.parse(coverageidentifier.value)
              : {};
            return coverageValue.origSysId;
          })
      );
      medicaidRN.push(
        filteredCoverageIdentifier
          .filter(identifiers => {
            return (
              "type" in identifiers &&
              "coding" in identifiers.type &&
              identifiers.type.coding.some(c => c.code === "COV")
            );
          })
          .map(coverageidentifier => {
            const coverageValue = coverageidentifier.value
              ? JSON.parse(coverageidentifier.value)
              : {};
            return coverageValue.medicaidRN;
          })
      );
    } else {
      policyNum.push([]);
      dependentCd.push([]);
      divisionCd.push([]);
      relationshipCd.push([]);
      familyID.push([]);
      memberID.push([]);
      subscriberID.push([]);
      carrierID.push([]);
      accountID.push([]);
      groupID.push([]);
      origSysId.push([]);
      medicaidRN.push([]);
    }

    const covEndDate = record.extension
      ? record.extension.filter(e => e.url.includes("coverageEndDate"))
      : [];
    if (covEndDate && covEndDate.length > 0) {
      covEndDate[0].valueDateTime
        ? coverageEndDate.push([
            formattedDateWithDefault(covEndDate[0].valueDateTime)
          ])
        : covEndDate[0].valueString
        ? coverageEndDate.push([
            formattedDateWithDefault(covEndDate[0].valueString)
          ])
        : coverageEndDate.push([]);
    } else {
      coverageEndDate.push([]);
    }
    if (record.eimpLastUpdated) {
      lastUpdated.push([lastUpdatedTimeCell(record.eimpLastUpdated)]);
    } else {
      lastUpdated.push([]);
    }
  }

  // add color information
  const colors = [
    "#fffff",
    "#8DCBE4",
    "#B5DDD8",
    "#D0E7CA",
    "#EAF0B5",
    "#FEFBE9"
  ];

  const familyNameKeys = [...new Set(familyNames.flat())];
  const givenNameKeys = [...new Set(givenNames.flat())];
  const nameUseKeys = [...new Set(nameUse.flat())];
  const addressLine1Keys = [...new Set(addressLines1.flat())];
  const addressLine2Keys = [...new Set(addressLines2.flat())];
  const cityKeys = [...new Set(cities.flat())];
  const postalCodeKeys = [...new Set(postalCodes.flat())];
  const addressUseKeys = [...new Set(addressUse.flat())];
  const stateCodeKeys = [...new Set(stateCode.flat())];
  const genderKeys = [...new Set(genders.flat())];
  const DOBKeys = [...new Set(DOBs.flat())];
  const phoneKeys = [...new Set(phones.flat())];
  const phoneUseKeys = [...new Set(phoneUse.flat())];
  const emailKeys = [...new Set(emails.flat())];
  const emailUseKeys = [...new Set(emailUse.flat())];
  const SSNKeys = [...new Set(SSNs.flat())];
  const MBIKeys = [...new Set(MBIs.flat())];
  const HICNKeys = [...new Set(HICNs.flat())];
  const CPINKeys = [...new Set(CPINs.flat())];
  const HSIDKeys = [...new Set(HSIDs.flat())];
  const MRNKeys = [...new Set(MRNs.flat())];
  const sourceKeys = [...new Set(sources.flat())];
  const otherIdentifierKeys = [...new Set(otherIdentifiers.flat())];
  const policyNumKeys = [...new Set(policyNum.flat())];
  const dependentCodeKeys = [...new Set(dependentCd.flat())];
  const divisionCodeKeys = [...new Set(divisionCd.flat())];
  const relationshipCodeKeys = [...new Set(relationshipCd.flat())];
  const familyIdKeys = [...new Set(familyID.flat())];
  const memberIDKeys = [...new Set(memberID.flat())];
  const subscriberIDKeys = [...new Set(subscriberID.flat())];
  const carrierIDKeys = [...new Set(carrierID.flat())];
  const accountIDKeys = [...new Set(accountID.flat())];
  const groupIDKeys = [...new Set(groupID.flat())];
  const origSysIdKeys = [...new Set(origSysId.flat())];
  const medicaidRNKeys = [...new Set(medicaidRN.flat())];
  const coverageEndDateKeys = [...new Set(coverageEndDate.flat())];
  //const otherIdentifierKeys = [...new Set(otherIdentifiers.flat())];
  const lastUpdatedKeys = [...new Set(lastUpdated.flat())];

  const colorKeyFamilyName = {};
  const colorKeyGivenName = {};
  const colorKeyNameUse = {};
  const colorKeyAddressLine1 = {};
  const colorKeyAddressLine2 = {};
  const colorKeyCities = {};
  const colorKeyPostalCodes = {};
  const colorKeyAddressUse = {};
  const colorKeyStateCode = {};
  const colorKeyGenders = {};
  const colorKeyDOBs = {};
  const colorKeyPhones = {};
  const colorKeyPhoneUse = {};
  const colorKeyEmails = {};
  const colorKeyEmailUse = {};
  const colorKeySSNs = {};
  const colorKeyMBIs = {};
  const colorKeyHICNs = {};
  const colorKeyCPINs = {};
  const colorKeyHSIDs = {};
  const colorKeyMRNs = {};
  const colorKeySources = {};
  const colorKeyOtherIdentifiers = {};
  const colorKeypolicyNum = {};
  const colorKeydependentCd = {};
  const colorKeydivisionCd = {};
  const colorKeyrelationshipCd = {};
  const colorKeyfamilyID = {};
  const colorKeymemberID = {};
  const colorKeysubscriberID = {};
  const colorKeycarrierID = {};
  const colorKeyaccountID = {};
  const colorKeygroupID = {};
  const colorKeyorigSysId = {};
  const colorKeymedicaidRN = {};
  const colorKeyCoverageEndDate = {};
  //const colorKeyOtherIdentifiers = {};
  const colorKeyLastUpdated = {};

  const getColor = index => {
    if (array.length > 6) {
      return colors[0];
    }
    return colors[index];
  };

  const compareAndReturnColor = (arr, colorKeyJson) => {
    if (!isOverlayRecordPage) {
      let flattened = arr.reduce((acc, curVal) => {
        let temp = curVal.length > 0 ? curVal : [null];
        return acc.concat(temp);
      }, []);

      return new Set(flattened).size > 1 ? colors[0] : colors[1];
    } else {
      return colorKeyJson;
    }
  };

  familyNameKeys.forEach((fname, index) => {
    colorKeyFamilyName[fname] = getColor(index);
  });
  givenNameKeys.forEach((gname, index) => {
    colorKeyGivenName[gname] = getColor(index);
  });
  nameUseKeys.forEach((use, index) => {
    colorKeyNameUse[use] = getColor(index);
  });

  addressLine1Keys.forEach((addLine, index) => {
    colorKeyAddressLine1[addLine] = getColor(index);
  });
  addressLine2Keys.forEach((addLine, index) => {
    colorKeyAddressLine2[addLine] = getColor(index);
  });
  cityKeys.forEach((city, index) => {
    colorKeyCities[city] = getColor(index);
  });
  postalCodeKeys.forEach((postalCode, index) => {
    colorKeyPostalCodes[postalCode] = getColor(index);
  });
  addressUseKeys.forEach((use, index) => {
    colorKeyAddressUse[use] = getColor(index);
  });
  stateCodeKeys.forEach((use, index) => {
    colorKeyStateCode[use] = getColor(index);
  });
  genderKeys.forEach((gender, index) => {
    colorKeyGenders[gender] = getColor(index);
  });
  DOBKeys.forEach((dob, index) => {
    colorKeyDOBs[dob] = getColor(index);
  });
  phoneKeys.forEach((phone, index) => {
    colorKeyPhones[phone] = getColor(index);
  });
  phoneUseKeys.forEach((phoneUse, index) => {
    colorKeyPhoneUse[phoneUse] = getColor(index);
  });
  emailKeys.forEach((email, index) => {
    colorKeyEmails[email] = getColor(index);
  });
  emailUseKeys.forEach((emailUse, index) => {
    colorKeyEmailUse[emailUse] = getColor(index);
  });

  SSNKeys.forEach((SSN, index) => {
    colorKeySSNs[SSN] = getColor(index);
  });

  MBIKeys.forEach((MBI, index) => {
    colorKeyMBIs[MBI] = getColor(index);
  });

  HICNKeys.forEach((HICN, index) => {
    colorKeyHICNs[HICN] = getColor(index);
  });

  CPINKeys.forEach((CPIN, index) => {
    colorKeyCPINs[CPIN] = getColor(index);
  });

  HSIDKeys.forEach((HSID, index) => {
    colorKeyHSIDs[HSID] = getColor(index);
  });

  MRNKeys.forEach((MRN, index) => {
    colorKeyMRNs[MRN] = getColor(index);
  });

  sourceKeys.forEach((source, index) => {
    colorKeySources[source] = getColor(index);
  });
  policyNumKeys.forEach((policyNum, index) => {
    colorKeypolicyNum[policyNum] = getColor(index);
  });
  dependentCodeKeys.forEach((dependentCd, index) => {
    colorKeydependentCd[dependentCd] = getColor(index);
  });
  divisionCodeKeys.forEach((divisionCd, index) => {
    colorKeydivisionCd[divisionCd] = getColor(index);
  });
  relationshipCodeKeys.forEach((relationshipCd, index) => {
    colorKeyrelationshipCd[relationshipCd] = getColor(index);
  });
  familyIdKeys.forEach((familyID, index) => {
    colorKeyfamilyID[familyID] = getColor(index);
  });
  memberIDKeys.forEach((memberID, index) => {
    colorKeymemberID[memberID] = getColor(index);
  });
  subscriberIDKeys.forEach((subscriberID, index) => {
    colorKeysubscriberID[subscriberID] = getColor(index);
  });
  carrierIDKeys.forEach((carrierID, index) => {
    colorKeycarrierID[carrierID] = getColor(index);
  });
  accountIDKeys.forEach((accountID, index) => {
    colorKeyaccountID[accountID] = getColor(index);
  });
  groupIDKeys.forEach((groupID, index) => {
    colorKeygroupID[groupID] = getColor(index);
  });
  origSysIdKeys.forEach((origSysId, index) => {
    colorKeyorigSysId[origSysId] = getColor(index);
  });
  medicaidRNKeys.forEach((medicaidRN, index) => {
    colorKeymedicaidRN[medicaidRN] = getColor(index);
  });
  coverageEndDateKeys.forEach((coverageEndDate, index) => {
    colorKeyCoverageEndDate[coverageEndDate] = getColor(index);
  });

  otherIdentifierKeys.forEach((otherIdenfiers, index) => {
    colorKeyOtherIdentifiers[otherIdenfiers] = getColor(index);
  });

  lastUpdatedKeys.forEach((use, index) => {
    colorKeyLastUpdated[use] = getColor(index);
  });

  const quarantineConfirmDialogUtil = () => {
    return (
      <Modal
        open={quarantineConfirmDialog}
        onClose={() => setQuarantineConfirmDialog(false)}
      >
        <div className={styles.bottomBanner}>
          <h2>Confirmation</h2>
        </div>

        <div style={{ marginTop: "1rem" }}>
          <div style={{ fontWeight: "bold", marginBottom: "0.5rem" }}>
            On pressing Confirm, you will be directed to the Focus Identity page
            where you need to review the identity.
          </div>
        </div>

        <div style={{ marginTop: "1rem" }}>
          <ButtonList
            style={{
              display: "flex",
              justifyContent: "center"
            }}
          >
            <Button
              primary
              onClick={() =>
                applyAndResolveOverlayRecordHandler(
                  array[2],
                  "in_progress",
                  fromSearchOverlay
                )
              }
            >
              Confirm
            </Button>
            <Button primary onClick={() => setQuarantineConfirmDialog(false)}>
              Cancel
            </Button>
          </ButtonList>
        </div>
      </Modal>
    );
  };

  return (
    <Layout>
      <Container>
        <Flex gutter={3}>
          {isOverlayRecordPage && (
            <Flex.Item span={12}>
              <Breadcrumbs>
                <Breadcrumbs.Item render={() => <Link to="/">Home</Link>} />
                <Breadcrumbs.Item
                  render={() => (
                    <Link to="/review-queue-dashboard">
                      Review Queue Dashboard
                    </Link>
                  )}
                />{" "}
                {!isQuarantineRecord ? "Overlays" : "Quarantine Records"}
              </Breadcrumbs>
            </Flex.Item>
          )}
          <Flex.Item span={12} className={styles.base}>
            <Content className={styles.i}>
              {isOverlayRecordPage && array.length > 0 && (
                <div className={styles.base}>
                  {!isQuarantineRecord ? (
                    <h1>Potential Record Overlay</h1>
                  ) : (
                    <h1>Quarantine Overlay Record</h1>
                  )}
                  <div className={styles.overlaysInfoBar}>
                    <span className={styles.overlaysRecordId}>
                      Record ID:&nbsp;&nbsp; {array[0].id}
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      <span className={styles.overlaysSourceId}>
                        Source System:&nbsp;&nbsp;{array[0].meta.source}
                      </span>
                    </span>
                    <span>
                      {" "}
                      {focusIdentityButtonHandler(
                        array[0].id,
                        array[0].meta.source
                      )}
                    </span>
                  </div>
                </div>
              )}
            </Content>
            <Content>
              {!isOverlayRecordPage && (
                <div style={{ width: "100%" }}>
                  <div style={{ width: "50%", float: "left" }}>
                    <h1>Compare Records</h1>
                  </div>
                  <div>
                    <ButtonList style={{ float: "right" }}>
                      <Button
                        onClick={() => {
                          if (zoomValue > 0.3) {
                            setZoomValue(zoomValue - 0.1);
                          } else {
                            setZoomWidth(zoomWidth - 1);
                          }
                        }}
                        disabled={zoomWidth < 6}
                      >
                        Zoom Out
                      </Button>
                      <Button
                        onClick={() => {
                          if (zoomWidth < 15) {
                            setZoomWidth(zoomWidth + 1);
                          } else {
                            setZoomValue(zoomValue + 0.1);
                          }
                        }}
                        disabled={zoomValue > 1.5}
                      >
                        Zoom In
                      </Button>
                      <Button
                        onClick={() => {
                          setZoomValue(1.0);
                          setZoomWidth(15);
                        }}
                        disabled={zoomValue === 1.0}
                      >
                        Reset
                      </Button>
                    </ButtonList>
                  </div>
                </div>
              )}
            </Content>
          </Flex.Item>

          {/* <Flex.Item span={12}>
              <div className={styles.base}>
                {isOverlayRecordPage && (
                  <div className={styles.undoContainer}>
                   <button className={styles.iconButton}><Icon type="undo" className={styles.icon} /> Undo All</button> 
                  </div>)}
                </div>
          </Flex.Item> */}

          <Flex.Item span={12}>
            {array.length > 0 ? (
              <div className={styles.base} style={{ zoom: zoomValue }}>
                <table className={styles.table}>
                  <tbody>
                    <tr>
                      {isOverlayRecordPage ? (
                        <th className={styles.th}>Attributes</th>
                      ) : (
                        <th className={styles.th}>Identities</th>
                      )}
                      {array.map((arr, index) => (
                        <td
                          key={index}
                          className={styles.td}
                          style={{ minWidth: zoomWidth + "rem" }}
                        >
                          {isOverlayRecordPage ? (
                            <div className={styles.card}>
                              {" "}
                              <span className={styles.overlaysHeadings}>
                                <b>
                                  {index === 0 && (
                                    <div
                                      className={
                                        styles.overlaysHeadingContainer
                                      }
                                    >
                                      <span className={styles.overlaysHeading}>
                                        {isQuarantineRecord
                                          ? "Current Record"
                                          : "Pre-Overlay Values"}
                                      </span>
                                      {!isQuarantineRecord ? (
                                        <button
                                          className={styles.icons}
                                          onClick={() =>
                                            recordOverrideHandler("preOverlay")
                                          }
                                        >
                                          <Icon type="data" />
                                          <Icon type="arrow_right" />
                                        </button>
                                      ) : null}
                                    </div>
                                  )}{" "}
                                </b>{" "}
                                <b>
                                  {index === 1 && (
                                    <div
                                      className={
                                        styles.overlaysHeadingContainer
                                      }
                                    >
                                      <span className={styles.overlaysHeading}>
                                        {isQuarantineRecord
                                          ? "Quarantine Record"
                                          : "Post-Overlay Values"}
                                      </span>
                                      {!isQuarantineRecord ? (
                                        <button
                                          className={styles.icons}
                                          onClick={() =>
                                            recordOverrideHandler("postOverlay")
                                          }
                                        >
                                          <Icon type="data" />
                                          <Icon type="arrow_right" />
                                        </button>
                                      ) : null}
                                    </div>
                                  )}{" "}
                                </b>{" "}
                                <b>
                                  {index === 2 && (
                                    <div
                                      className={
                                        styles.overlaysHeadingContainer
                                      }
                                    >
                                      <span className={styles.overlaysHeading}>
                                        {isQuarantineRecord
                                          ? "Final Record"
                                          : "Current Value"}
                                      </span>
                                    </div>
                                  )}{" "}
                                </b>{" "}
                              </span>
                            </div>
                          ) : (
                            <div className={styles.card}>
                              <div>
                                {" "}
                                <span>
                                  <b>{isImdm ? "EID" : "HCM ID"}</b>{" "}
                                </span>
                                <span>{arr.link[0].other.reference}</span>{" "}
                              </div>
                              <div>
                                <span>
                                  <b>RECORD ID </b>
                                </span>
                                <span>{arr.id}</span>
                              </div>
                            </div>
                          )}
                        </td>
                      ))}
                    </tr>

                    <tr>
                      <th
                        className={`${styles.th} ${styles.shifted}`}
                        style={{
                          backgroundColor: compareAndReturnColor(sources)
                        }}
                      >
                        Source ID
                      </th>
                      {sources.map((source, index) => (
                        <td
                          key={index}
                          className={styles.td}
                          style={{ minWidth: zoomWidth + "rem" }}
                        >
                          <InnerTableComponent
                            cells={source}
                            colorKey={compareAndReturnColor(
                              sources,
                              colorKeySources
                            )}
                          />
                        </td>
                      ))}
                    </tr>
                    <tr>
                      <th className={styles.th}>Names</th>
                      {array.map((arr, index) => (
                        <td
                          key={index}
                          className={styles.td}
                          style={{ minWidth: zoomWidth + "rem" }}
                        ></td>
                      ))}
                    </tr>
                    <tr>
                      <th
                        className={`${styles.th} ${styles.shifted}`}
                        style={{
                          backgroundColor: compareAndReturnColor(familyNames)
                        }}
                      >
                        Family Name
                      </th>
                      {familyNames.map((familyName, index) => (
                        <td
                          key={index}
                          className={styles.td}
                          style={{ minWidth: zoomWidth + "rem" }}
                        >
                          <InnerTableComponent
                            cells={familyName}
                            colorKey={compareAndReturnColor(
                              familyNames,
                              colorKeyFamilyName
                            )}
                          />
                        </td>
                      ))}
                    </tr>
                    <tr>
                      <th
                        className={`${styles.th} ${styles.shifted}`}
                        style={{
                          backgroundColor: compareAndReturnColor(givenNames)
                        }}
                      >
                        Given Name
                      </th>
                      {givenNames.map((gName, index) => (
                        <td
                          key={index}
                          className={styles.td}
                          style={{ minWidth: zoomWidth + "rem" }}
                        >
                          <InnerTableComponent
                            cells={gName}
                            colorKey={compareAndReturnColor(
                              givenNames,
                              colorKeyGivenName
                            )}
                          />
                        </td>
                      ))}
                    </tr>
                    <tr>
                      <th
                        className={`${styles.th} ${styles.shifted}`}
                        style={{
                          backgroundColor: compareAndReturnColor(nameUse)
                        }}
                      >
                        {" "}
                        Use
                      </th>
                      {nameUse.map((use, index) => (
                        <td
                          key={index}
                          className={styles.td}
                          style={{ minWidth: zoomWidth + "rem" }}
                        >
                          <InnerTableComponent
                            cells={use}
                            colorKey={compareAndReturnColor(
                              nameUse,
                              colorKeyNameUse
                            )}
                          />
                        </td>
                      ))}
                    </tr>
                    <tr>
                      <th className={styles.th}>Addresses</th>
                      {array.map((arr, index) => (
                        <td
                          key={index}
                          className={styles.td}
                          style={{ minWidth: zoomWidth + "rem" }}
                        ></td>
                      ))}
                    </tr>
                    <tr>
                      <th
                        className={`${styles.th} ${styles.shifted}`}
                        style={{
                          backgroundColor: compareAndReturnColor(addressLines1)
                        }}
                      >
                        Address Line 1
                      </th>
                      {addressLines1.map((line, index) => (
                        <td
                          key={index}
                          className={styles.td}
                          style={{ minWidth: zoomWidth + "rem" }}
                        >
                          <InnerTableComponent
                            cells={line}
                            colorKey={compareAndReturnColor(
                              addressLines1,
                              colorKeyAddressLine1
                            )}
                          />
                        </td>
                      ))}
                    </tr>
                    <tr>
                      <th
                        className={`${styles.th} ${styles.shifted}`}
                        style={{
                          backgroundColor: compareAndReturnColor(addressLines2)
                        }}
                      >
                        Address Line 2
                      </th>
                      {addressLines2.map((line, index) => (
                        <td
                          key={index}
                          className={styles.td}
                          style={{ minWidth: zoomWidth + "rem" }}
                        >
                          <InnerTableComponent
                            cells={line}
                            colorKey={compareAndReturnColor(
                              addressLines2,
                              colorKeyAddressLine2
                            )}
                          />
                        </td>
                      ))}
                    </tr>
                    <tr>
                      <th
                        className={`${styles.th} ${styles.shifted}`}
                        style={{
                          backgroundColor: compareAndReturnColor(cities)
                        }}
                      >
                        City
                      </th>
                      {cities.map((city, index) => (
                        <td
                          key={index}
                          className={styles.td}
                          style={{ minWidth: zoomWidth + "rem" }}
                        >
                          <InnerTableComponent
                            cells={city}
                            colorKey={compareAndReturnColor(
                              cities,
                              colorKeyCities
                            )}
                          />
                        </td>
                      ))}
                    </tr>
                    <tr>
                      <th
                        className={`${styles.th} ${styles.shifted}`}
                        style={{
                          backgroundColor: compareAndReturnColor(stateCode)
                        }}
                      >
                        State
                      </th>
                      {stateCode.map((code, index) => (
                        <td
                          key={index}
                          className={styles.td}
                          style={{ minWidth: zoomWidth + "rem" }}
                        >
                          <InnerTableComponent
                            cells={code}
                            colorKey={compareAndReturnColor(
                              stateCode,
                              colorKeyStateCode
                            )}
                          />
                        </td>
                      ))}
                    </tr>
                    <tr>
                      <th
                        className={`${styles.th} ${styles.shifted}`}
                        style={{
                          backgroundColor: compareAndReturnColor(postalCodes)
                        }}
                      >
                        Postal Code
                      </th>
                      {postalCodes.map((code, index) => (
                        <td
                          key={index}
                          className={styles.td}
                          style={{ minWidth: zoomWidth + "rem" }}
                        >
                          <InnerTableComponent
                            cells={code}
                            colorKey={compareAndReturnColor(
                              postalCodes,
                              colorKeyPostalCodes
                            )}
                          />
                        </td>
                      ))}
                    </tr>
                    <tr>
                      <th
                        className={`${styles.th} ${styles.shifted}`}
                        style={{
                          backgroundColor: compareAndReturnColor(addressUse)
                        }}
                      >
                        Use
                      </th>
                      {addressUse.map((use, index) => (
                        <td
                          key={index}
                          className={styles.td}
                          style={{ minWidth: zoomWidth + "rem" }}
                        >
                          <InnerTableComponent
                            cells={use}
                            colorKey={compareAndReturnColor(
                              addressUse,
                              colorKeyAddressUse
                            )}
                          />
                        </td>
                      ))}
                    </tr>
                    <tr>
                      <th className={styles.th}>Basic Demographics</th>
                      {array.map((arr, index) => (
                        <td
                          key={index}
                          className={styles.td}
                          style={{ minWidth: zoomWidth + "rem" }}
                        ></td>
                      ))}
                    </tr>
                    <tr>
                      <th
                        className={`${styles.th} ${styles.shifted}`}
                        style={{
                          backgroundColor: compareAndReturnColor(genders)
                        }}
                      >
                        Gender
                      </th>
                      {genders.map((gender, index) => (
                        <td
                          key={index}
                          className={styles.td}
                          style={{ minWidth: zoomWidth + "rem" }}
                        >
                          <InnerTableComponent
                            cells={gender}
                            colorKey={compareAndReturnColor(
                              genders,
                              colorKeyGenders
                            )}
                          />
                        </td>
                      ))}
                    </tr>
                    <tr>
                      <th
                        className={`${styles.th} ${styles.shifted}`}
                        style={{ backgroundColor: compareAndReturnColor(DOBs) }}
                      >
                        Date of Birth
                      </th>
                      {DOBs.map((dob, index) => (
                        <td
                          key={index}
                          className={styles.td}
                          style={{ minWidth: zoomWidth + "rem" }}
                        >
                          <InnerTableComponent
                            cells={dob}
                            colorKey={compareAndReturnColor(DOBs, colorKeyDOBs)}
                          />
                        </td>
                      ))}
                    </tr>
                    <tr>
                      <th className={styles.th}>Contact Information</th>
                      {array.map((arr, index) => (
                        <td
                          key={index}
                          className={styles.td}
                          style={{ minWidth: zoomWidth + "rem" }}
                        ></td>
                      ))}
                    </tr>
                    <tr>
                      <th
                        className={`${styles.th} ${styles.shifted}`}
                        style={{
                          backgroundColor: compareAndReturnColor(phones)
                        }}
                      >
                        Phone
                      </th>
                      {phones.map((phone, index) => (
                        <td
                          key={index}
                          className={styles.td}
                          style={{ minWidth: zoomWidth + "rem" }}
                        >
                          <InnerTableComponent
                            cells={phone}
                            colorKey={compareAndReturnColor(
                              phones,
                              colorKeyPhones
                            )}
                          />
                        </td>
                      ))}
                    </tr>
                    <tr>
                      <th
                        className={`${styles.th} ${styles.shifted}`}
                        style={{
                          backgroundColor: compareAndReturnColor(phoneUse)
                        }}
                      >
                        Use
                      </th>
                      {phoneUse.map((use, index) => (
                        <td
                          key={index}
                          className={styles.td}
                          style={{ minWidth: zoomWidth + "rem" }}
                        >
                          <InnerTableComponent
                            cells={use}
                            colorKey={compareAndReturnColor(
                              phoneUse,
                              colorKeyPhoneUse
                            )}
                          />
                        </td>
                      ))}
                    </tr>
                    <tr>
                      <th
                        className={`${styles.th} ${styles.shifted}`}
                        style={{
                          backgroundColor: compareAndReturnColor(emails)
                        }}
                      >
                        Email
                      </th>
                      {emails.map((email, index) => (
                        <td
                          key={index}
                          className={styles.td}
                          style={{ minWidth: zoomWidth + "rem" }}
                        >
                          <InnerTableComponent
                            cells={email}
                            colorKey={compareAndReturnColor(
                              emails,
                              colorKeyEmails
                            )}
                          />
                        </td>
                      ))}
                    </tr>
                    <tr>
                      <th
                        className={`${styles.th} ${styles.shifted}`}
                        style={{
                          backgroundColor: compareAndReturnColor(emailUse)
                        }}
                      >
                        Use
                      </th>
                      {emailUse.map((use, index) => (
                        <td
                          key={index}
                          className={styles.td}
                          style={{ minWidth: zoomWidth + "rem" }}
                        >
                          <InnerTableComponent
                            cells={use}
                            colorKey={compareAndReturnColor(
                              emailUse,
                              colorKeyEmailUse
                            )}
                          />
                        </td>
                      ))}
                    </tr>
                    <tr>
                      <th className={styles.th}>Identifier</th>
                      {array.map((arr, index) => (
                        <td
                          key={index}
                          className={styles.td}
                          style={{ minWidth: zoomWidth + "rem" }}
                        ></td>
                      ))}
                    </tr>
                    <tr>
                      <th
                        className={`${styles.th} ${styles.shifted}`}
                        style={{ backgroundColor: compareAndReturnColor(SSNs) }}
                      >
                        SSN
                      </th>
                      {SSNs.map((ssn, index) => (
                        <td
                          key={index}
                          className={styles.td}
                          style={{ minWidth: zoomWidth + "rem" }}
                        >
                          <InnerTableComponent
                            cells={ssn}
                            colorKey={compareAndReturnColor(SSNs, colorKeySSNs)}
                          />
                        </td>
                      ))}
                    </tr>
                    <tr>
                      <th
                        className={`${styles.th} ${styles.shifted}`}
                        style={{ backgroundColor: compareAndReturnColor(MBIs) }}
                      >
                        MBI
                      </th>
                      {MBIs.map((mbi, index) => (
                        <td
                          key={index}
                          className={styles.td}
                          style={{ minWidth: zoomWidth + "rem" }}
                        >
                          <InnerTableComponent
                            cells={mbi}
                            colorKey={compareAndReturnColor(MBIs, colorKeyMBIs)}
                          />
                        </td>
                      ))}
                    </tr>
                    <tr>
                      <th
                        className={`${styles.th} ${styles.shifted}`}
                        style={{
                          backgroundColor: compareAndReturnColor(HICNs)
                        }}
                      >
                        HICN
                      </th>
                      {HICNs.map((hicn, index) => (
                        <td
                          key={index}
                          className={styles.td}
                          style={{ minWidth: zoomWidth + "rem" }}
                        >
                          <InnerTableComponent
                            cells={hicn}
                            colorKey={compareAndReturnColor(
                              HICNs,
                              colorKeyHICNs
                            )}
                          />
                        </td>
                      ))}
                    </tr>
                    <tr>
                      <th
                        className={`${styles.th} ${styles.shifted}`}
                        style={{
                          backgroundColor: compareAndReturnColor(CPINs)
                        }}
                      >
                        CPIN
                      </th>
                      {CPINs.map((cpin, index) => (
                        <td
                          key={index}
                          className={styles.td}
                          style={{ minWidth: zoomWidth + "rem" }}
                        >
                          <InnerTableComponent
                            cells={cpin}
                            colorKey={compareAndReturnColor(
                              CPINs,
                              colorKeyCPINs
                            )}
                          />
                        </td>
                      ))}
                    </tr>
                    <tr>
                      <th
                        className={`${styles.th} ${styles.shifted}`}
                        style={{
                          backgroundColor: compareAndReturnColor(HSIDs)
                        }}
                      >
                        HSID
                      </th>
                      {HSIDs.map((hsid, index) => (
                        <td
                          key={index}
                          className={styles.td}
                          style={{ minWidth: zoomWidth + "rem" }}
                        >
                          <InnerTableComponent
                            cells={hsid}
                            colorKey={compareAndReturnColor(
                              HSIDs,
                              colorKeyHSIDs
                            )}
                          />
                        </td>
                      ))}
                    </tr>
                    <tr>
                      <th
                        className={`${styles.th} ${styles.shifted}`}
                        style={{ backgroundColor: compareAndReturnColor(MRNs) }}
                      >
                        MRN
                      </th>
                      {MRNs.map((mrn, index) => (
                        <td
                          key={index}
                          className={styles.td}
                          style={{ minWidth: zoomWidth + "rem" }}
                        >
                          <InnerTableComponent
                            cells={mrn}
                            colorKey={compareAndReturnColor(MRNs, colorKeyMRNs)}
                          />
                        </td>
                      ))}
                    </tr>
                    <tr>
                      <th
                        className={`${styles.th} ${styles.shifted}`}
                        style={{
                          backgroundColor: compareAndReturnColor(
                            otherIdentifiers
                          )
                        }}
                      >
                        Other Identifiers
                      </th>
                      {otherIdentifiers.map((otherIdentifier, index) => (
                        <td
                          key={index}
                          className={styles.td}
                          style={{ minWidth: zoomWidth + "rem" }}
                        >
                          <InnerTableComponent
                            cells={otherIdentifier}
                            colorKey={compareAndReturnColor(
                              otherIdentifiers,
                              colorKeyOtherIdentifiers
                            )}
                          />
                        </td>
                      ))}
                    </tr>
                    {/* {isImdm} */}
                    <tr>
                      <th className={styles.th}>HealthCare</th>
                      {isImdm &&
                        array.map((arr, index) => (
                          <td
                            key={index}
                            className={styles.td}
                            style={{ minWidth: zoomWidth + "rem" }}
                          ></td>
                        ))}
                    </tr>
                    <tr>
                      <th
                        className={`${styles.th} ${styles.shifted}`}
                        style={{
                          backgroundColor: compareAndReturnColor(policyNum)
                        }}
                      >
                        policyNum
                      </th>
                      {isImdm &&
                        policyNum.map((line, index) => (
                          <td
                            key={index}
                            className={styles.td}
                            style={{ minWidth: zoomWidth + "rem" }}
                          >
                            <InnerTableComponent
                              cells={line}
                              colorKey={compareAndReturnColor(
                                policyNum,
                                colorKeypolicyNum
                              )}
                            />
                          </td>
                        ))}
                    </tr>
                    <tr>
                      <th
                        className={`${styles.th} ${styles.shifted}`}
                        style={{
                          backgroundColor: compareAndReturnColor(dependentCd)
                        }}
                      >
                        dependentCd
                      </th>
                      {isImdm &&
                        dependentCd.map((line, index) => (
                          <td
                            key={index}
                            className={styles.td}
                            style={{ minWidth: zoomWidth + "rem" }}
                          >
                            <InnerTableComponent
                              cells={line}
                              colorKey={compareAndReturnColor(
                                dependentCd,
                                colorKeydependentCd
                              )}
                            />
                          </td>
                        ))}
                    </tr>
                    <tr>
                      <th
                        className={`${styles.th} ${styles.shifted}`}
                        style={{
                          backgroundColor: compareAndReturnColor(divisionCd)
                        }}
                      >
                        divisionCd
                      </th>
                      {isImdm &&
                        divisionCd.map((line, index) => (
                          <td
                            key={index}
                            className={styles.td}
                            style={{ minWidth: zoomWidth + "rem" }}
                          >
                            <InnerTableComponent
                              cells={line}
                              colorKey={compareAndReturnColor(
                                divisionCd,
                                colorKeydivisionCd
                              )}
                            />
                          </td>
                        ))}
                    </tr>
                    <tr>
                      <th
                        className={`${styles.th} ${styles.shifted}`}
                        style={{
                          backgroundColor: compareAndReturnColor(relationshipCd)
                        }}
                      >
                        relationshipCd
                      </th>
                      {isImdm &&
                        relationshipCd.map((line, index) => (
                          <td
                            key={index}
                            className={styles.td}
                            style={{ minWidth: zoomWidth + "rem" }}
                          >
                            <InnerTableComponent
                              cells={line}
                              colorKey={compareAndReturnColor(
                                relationshipCd,
                                colorKeyrelationshipCd
                              )}
                            />
                          </td>
                        ))}
                    </tr>
                    <tr>
                      <th
                        className={`${styles.th} ${styles.shifted}`}
                        style={{
                          backgroundColor: compareAndReturnColor(familyID)
                        }}
                      >
                        familyID
                      </th>
                      {isImdm &&
                        familyID.map((line, index) => (
                          <td
                            key={index}
                            className={styles.td}
                            style={{ minWidth: zoomWidth + "rem" }}
                          >
                            <InnerTableComponent
                              cells={line}
                              colorKey={compareAndReturnColor(
                                familyID,
                                colorKeyfamilyID
                              )}
                            />
                          </td>
                        ))}
                    </tr>
                    <tr>
                      <th
                        className={`${styles.th} ${styles.shifted}`}
                        style={{
                          backgroundColor: compareAndReturnColor(memberID)
                        }}
                      >
                        memberID
                      </th>
                      {isImdm &&
                        memberID.map((line, index) => (
                          <td
                            key={index}
                            className={styles.td}
                            style={{ minWidth: zoomWidth + "rem" }}
                          >
                            <InnerTableComponent
                              cells={line}
                              colorKey={compareAndReturnColor(
                                memberID,
                                colorKeymemberID
                              )}
                            />
                          </td>
                        ))}
                    </tr>
                    <tr>
                      <th
                        className={`${styles.th} ${styles.shifted}`}
                        style={{
                          backgroundColor: compareAndReturnColor(subscriberID)
                        }}
                      >
                        subscriberID
                      </th>
                      {isImdm &&
                        subscriberID.map((line, index) => (
                          <td
                            key={index}
                            className={styles.td}
                            style={{ minWidth: zoomWidth + "rem" }}
                          >
                            <InnerTableComponent
                              cells={line}
                              colorKey={compareAndReturnColor(
                                subscriberID,
                                colorKeysubscriberID
                              )}
                            />
                          </td>
                        ))}
                    </tr>
                    <tr>
                      <th
                        className={`${styles.th} ${styles.shifted}`}
                        style={{
                          backgroundColor: compareAndReturnColor(carrierID)
                        }}
                      >
                        carrierID
                      </th>
                      {isImdm &&
                        carrierID.map((line, index) => (
                          <td
                            key={index}
                            className={styles.td}
                            style={{ minWidth: zoomWidth + "rem" }}
                          >
                            <InnerTableComponent
                              cells={line}
                              colorKey={compareAndReturnColor(
                                carrierID,
                                colorKeycarrierID
                              )}
                            />
                          </td>
                        ))}
                    </tr>
                    <tr>
                      <th
                        className={`${styles.th} ${styles.shifted}`}
                        style={{
                          backgroundColor: compareAndReturnColor(accountID)
                        }}
                      >
                        accountID
                      </th>
                      {isImdm &&
                        accountID.map((line, index) => (
                          <td
                            key={index}
                            className={styles.td}
                            style={{ minWidth: zoomWidth + "rem" }}
                          >
                            <InnerTableComponent
                              cells={line}
                              colorKey={compareAndReturnColor(
                                accountID,
                                colorKeyaccountID
                              )}
                            />
                          </td>
                        ))}
                    </tr>
                    <tr>
                      <th
                        className={`${styles.th} ${styles.shifted}`}
                        style={{
                          backgroundColor: compareAndReturnColor(groupID)
                        }}
                      >
                        groupID
                      </th>
                      {isImdm &&
                        groupID.map((line, index) => (
                          <td
                            key={index}
                            className={styles.td}
                            style={{ minWidth: zoomWidth + "rem" }}
                          >
                            <InnerTableComponent
                              cells={line}
                              colorKey={compareAndReturnColor(
                                groupID,
                                colorKeygroupID
                              )}
                            />
                          </td>
                        ))}
                    </tr>
                    <tr>
                      <th
                        className={`${styles.th} ${styles.shifted}`}
                        style={{
                          backgroundColor: compareAndReturnColor(origSysId)
                        }}
                      >
                        origSysId
                      </th>
                      {isImdm &&
                        origSysId.map((line, index) => (
                          <td
                            key={index}
                            className={styles.td}
                            style={{ minWidth: zoomWidth + "rem" }}
                          >
                            <InnerTableComponent
                              cells={line}
                              colorKey={compareAndReturnColor(
                                origSysId,
                                colorKeyorigSysId
                              )}
                            />
                          </td>
                        ))}
                    </tr>
                    <tr>
                      <th
                        className={`${styles.th} ${styles.shifted}`}
                        style={{
                          backgroundColor: compareAndReturnColor(medicaidRN)
                        }}
                      >
                        medicaidRN
                      </th>
                      {isImdm &&
                        medicaidRN.map((line, index) => (
                          <td
                            key={index}
                            className={styles.td}
                            style={{ minWidth: zoomWidth + "rem" }}
                          >
                            <InnerTableComponent
                              cells={line}
                              colorKey={compareAndReturnColor(
                                medicaidRN,
                                colorKeymedicaidRN
                              )}
                            />
                          </td>
                        ))}
                    </tr>
                    <tr>
                      <th
                        className={`${styles.th} ${styles.shifted}`}
                        style={{
                          backgroundColor: compareAndReturnColor(
                            coverageEndDate
                          )
                        }}
                      >
                        coverageEndDate
                      </th>
                      {isImdm &&
                        coverageEndDate.map((line, index) => (
                          <td
                            key={index}
                            className={styles.td}
                            style={{ minWidth: zoomWidth + "rem" }}
                          >
                            <InnerTableComponent
                              cells={line}
                              colorKey={compareAndReturnColor(
                                coverageEndDate,
                                colorKeyCoverageEndDate
                              )}
                            />
                          </td>
                        ))}
                    </tr>
                    <tr>
                      <th className={styles.th}>Meta</th>
                      {array.map((arr, index) => (
                        <td
                          key={index}
                          className={styles.td}
                          style={{ minWidth: zoomWidth + "rem" }}
                        ></td>
                      ))}
                    </tr>
                    <tr>
                      <th
                        className={`${styles.th} ${styles.shifted}`}
                        style={{
                          backgroundColor: compareAndReturnColor(lastUpdated)
                        }}
                      >
                        Last Update Time
                      </th>
                      {lastUpdated.map((time, index) => (
                        <td
                          key={index}
                          className={styles.td}
                          style={{ minWidth: zoomWidth + "rem" }}
                        >
                          <InnerTableComponent
                            cells={time}
                            colorKey={compareAndReturnColor(
                              lastUpdated,
                              colorKeyLastUpdated
                            )}
                          />
                        </td>
                      ))}
                    </tr>
                  </tbody>
                </table>
              </div>
            ) : !afterRepartitionHasUpdates ? (
              <div
                style={{
                  padding: "2rem",
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize: "2rem"
                }}
              >
                No changes after repartiton.
              </div>
            ) : beforeRepartitionRecords.length > 0 ? (
              <div className={styles.base} style={{ zoom: zoomValue }}>
                <h2 className={styles.h1} style={{ marginBottom: "1rem" }}>
                  Repartition preview:
                </h2>
                <table
                  className={styles.table}
                  style={{ tableLayout: "auto", width: "100%" }}
                >
                  <thead>
                    <tr>
                      <th className={styles.th}></th>
                      <th className={styles.th}>Before Repartition</th>
                      <th className={styles.th}>After Repartition</th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* Golden Record */}
                    <tr>
                      <th
                        className={styles.th}
                        colSpan={3}
                        style={{ background: "#f5f5f5" }}
                      >
                        EnterpriseID: {goldenRecord?.id || ""}
                      </th>
                    </tr>
                    <tr>
                      <th className={styles.th}>&nbsp;&nbsp;&nbsp;Name</th>
                      <td
                        className={styles.td}
                        style={{ verticalAlign: "middle" }}
                      >
                        &nbsp;&nbsp;&nbsp;{getPreferredName(goldenRecord, true)}
                      </td>
                      <td
                        className={styles.td}
                        style={{ verticalAlign: "middle" }}
                      >
                        &nbsp;&nbsp;&nbsp;
                        {(() => {
                          const afterPatient =
                            afterRepartitionMap[goldenRecord?.id];
                          if (afterPatient)
                            matchedAfterIds.add(goldenRecord.id);
                          return afterPatient
                            ? getPreferredName(afterPatient, true)
                            : getPreferredName(goldenRecord, true);
                        })()}
                      </td>
                    </tr>
                    <tr>
                      <th className={styles.th}>
                        &nbsp;&nbsp;&nbsp;Date of Birth
                      </th>
                      <td
                        className={styles.td}
                        style={{ verticalAlign: "middle" }}
                      >
                        &nbsp;&nbsp;&nbsp;{goldenRecord?.birthDate || ""}
                      </td>
                      <td
                        className={styles.td}
                        style={{ verticalAlign: "middle" }}
                      >
                        &nbsp;&nbsp;&nbsp;
                        {(() => {
                          const afterPatient =
                            afterRepartitionMap[goldenRecord?.id];
                          return (
                            afterPatient?.birthDate ||
                            goldenRecord?.birthDate ||
                            ""
                          );
                        })()}
                      </td>
                    </tr>
                    <tr>
                      <th className={styles.th}>&nbsp;&nbsp;&nbsp;Gender</th>
                      <td
                        className={styles.td}
                        style={{ verticalAlign: "middle" }}
                      >
                        &nbsp;&nbsp;&nbsp;{goldenRecord?.gender || ""}
                      </td>
                      <td
                        className={styles.td}
                        style={{ verticalAlign: "middle" }}
                      >
                        &nbsp;&nbsp;&nbsp;
                        {(() => {
                          const afterPatient =
                            afterRepartitionMap[goldenRecord?.id];
                          return (
                            afterPatient?.gender || goldenRecord?.gender || ""
                          );
                        })()}
                      </td>
                    </tr>
                    {/* Add Records heading */}
                    <tr>
                      <th
                        className={styles.th}
                        colSpan={3}
                        style={{ background: "#f5f5f5" }}
                      >
                        <span style={{ fontWeight: "bold" }}>Records:</span>
                      </th>
                    </tr>
                    {/* Print all record IDs for this golden record (excluding goldenRecord itself) */}
                    {recordEntries.map((record, idx) => (
                      <tr key={record.id || idx}>
                        <th className={styles.th}>
                          &nbsp;&nbsp;&nbsp;{`Record ID${idx + 1}`}
                        </th>
                        <td
                          className={styles.td}
                          style={{ verticalAlign: "middle" }}
                        >
                          &nbsp;&nbsp;&nbsp;{record.id || ""}
                        </td>
                        <td
                          className={styles.td}
                          style={{ verticalAlign: "middle" }}
                        >
                          &nbsp;&nbsp;&nbsp;
                          {!afterRepartitionMap[record.id] ||
                          (afterRepartitionMap[record.id] &&
                            afterRepartitionMap[record.id]._golden_id ===
                              searchedGoldenId)
                            ? record.id
                            : ""}
                        </td>
                      </tr>
                    ))}
                    {/* Render unmatched After Repartition records */}
                    {Object.entries(
                      patients.reduce((acc, { source_entity_id, patient }) => {
                        const goldenId =
                          patient._golden_id || "Unknown Golden ID";
                        if (!acc[goldenId]) acc[goldenId] = [];
                        acc[goldenId].push({ source_entity_id, patient });
                        return acc;
                      }, {})
                    ).map(([goldenId, records]) => {
                      // Check if the Golden ID is new or existing
                      const isExistingGoldenId = beforeRepartitionRecords.some(
                        record => record.id === goldenId
                      );

                      // Extract survived values (name, dob, gender) from the first record
                      const survivedPatient = records[0]?.patient || {};
                      const survivedName = getPreferredName(survivedPatient);
                      const survivedDob = survivedPatient.birthDate || "";
                      const survivedGender = survivedPatient.gender || "";

                      return (
                        <React.Fragment key={goldenId}>
                          <tr>
                            <th
                              className={styles.th}
                              colSpan={3}
                              style={{ background: "#f5f5f5" }}
                            >
                              <span
                                style={{ fontWeight: "bold", color: "#b8860b" }}
                              >
                                EnterpriseID:
                              </span>
                              <span
                                style={{
                                  background: "#fff7b2",
                                  fontWeight: "bold",
                                  padding: "2px 8px",
                                  borderRadius: "4px",
                                  marginLeft: "8px",
                                  color: "#333"
                                }}
                              >
                                {goldenId}{" "}
                                {isExistingGoldenId
                                  ? "(Existing EID)"
                                  : "(New EID Created Post Repartition)"}
                              </span>
                            </th>
                          </tr>
                          <tr>
                            <th className={styles.th}>
                              &nbsp;&nbsp;&nbsp;Name
                            </th>
                            <td className={styles.td}>&nbsp;&nbsp;&nbsp;</td>
                            <td
                              className={styles.td}
                              style={{ verticalAlign: "middle" }}
                            >
                              &nbsp;&nbsp;&nbsp;{survivedName}
                            </td>
                          </tr>
                          <tr>
                            <th className={styles.th}>
                              &nbsp;&nbsp;&nbsp;Date of Birth
                            </th>
                            <td className={styles.td}>&nbsp;&nbsp;&nbsp;</td>
                            <td
                              className={styles.td}
                              style={{ verticalAlign: "middle" }}
                            >
                              &nbsp;&nbsp;&nbsp;{survivedDob}
                            </td>
                          </tr>
                          <tr>
                            <th className={styles.th}>
                              &nbsp;&nbsp;&nbsp;Gender
                            </th>
                            <td className={styles.td}>&nbsp;&nbsp;&nbsp;</td>
                            <td
                              className={styles.td}
                              style={{ verticalAlign: "middle" }}
                            >
                              &nbsp;&nbsp;&nbsp;{survivedGender}
                            </td>
                          </tr>
                          {/* Add Records heading */}
                          <tr>
                            <th
                              className={styles.th}
                              colSpan={3}
                              style={{ background: "#f5f5f5" }}
                            >
                              <span
                                style={{ fontWeight: "bold", color: "#b8860b" }}
                              >
                                Records:
                              </span>
                            </th>
                          </tr>
                          {/* Print all record IDs */}
                          {records.map(({ patient }, idx) => (
                            <tr key={patient.id || idx}>
                              <th className={styles.th}>
                                &nbsp;&nbsp;&nbsp;{`Record ID${idx + 1}`}
                              </th>
                              <td className={styles.td}>&nbsp;&nbsp;&nbsp;</td>
                              <td
                                className={styles.td}
                                style={{ verticalAlign: "middle" }}
                              >
                                &nbsp;&nbsp;&nbsp;{patient.id || ""}
                              </td>
                            </tr>
                          ))}
                        </React.Fragment>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            ) : (
              <div>No records to compare</div>
            )}
          </Flex.Item>

          {isOverlayRecordPage &&
            !isQuarantineRecord &&
            !location.pathname.includes("repartition-preview") && (
              <div className={styles.marginAuto}>
                <Flex.Item>
                  <div className={styles.base}>
                    <div></div>
                    <ButtonList className={styles.buttonList}>
                      <div>
                        <Button
                          width="12rem"
                          primary
                          onClick={() =>
                            applyAndResolveOverlayRecordHandler(
                              array[2],
                              fromSearchOverlay
                            )
                          }
                          isInvisible={checkReadOnlyUser(user)}
                        >
                          Apply Changes
                        </Button>
                      </div>
                      <div>
                        <Button
                          width="12rem"
                          onClick={() =>
                            skipAndReviewHandler("Reviewed", fromSearchOverlay)
                          }
                          isInvisible={checkReadOnlyUser(user)}
                        >
                          Review
                        </Button>
                      </div>
                      {!fromSearchOverlay && (
                        <div>
                          <LinkButton
                            onClick={() => skipAndReviewHandler("Unassigned")}
                          >
                            Skip
                          </LinkButton>
                        </div>
                      )}
                    </ButtonList>
                  </div>
                </Flex.Item>
              </div>
            )}
        </Flex>
      </Container>
      {quarantineConfirmDialogUtil()}
    </Layout>
  );
};

export default CompareRecords;
